import instance from 'utils/axiosConfig';
import axios from 'axios';

/**
 * 로그인 API
 * @param {Object} credentials - 로그인 정보
 * @param {string} credentials.username - 사용자 이름
 * @param {string} credentials.password - 비밀번호
 * @returns {Promise} API 응답
 */
export const login = async (credentials) => {
    try {
        const response = await instance.post('/api/v1/auth/login', credentials);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const logout = async (credentials) => {
    try {
        const response = await instance.post('/api/v1/auth/logout', credentials);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * 비밀번호 변경 API
 * @param {Object} params - 비밀번호 변경 데이터
 * @returns {Promise} API 응답 - 비밀번호 변경 결과
 */
export const changePassword = async (params) => {
    try {
        const response = await instance.post('/api/v1/auth/password/change', params);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * 액세스 토큰 갱신 API
 * @param {string} params - 리프레시 토큰
 * @returns {Promise} API 응답 - 새로운 액세스 토큰
 */
export const refreshAccessToken = async (params) => {
    try {
        const request = axios.create({
            baseURL: process.env.REACT_APP_API_ENDPOINT
        });

        const response = await request.post('/api/v1/auth/token/refresh', { refresh_token: params });
        return response.data;
    } catch (error) {
        throw error;
    }
};
